import {Component, Input, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {TaskService} from '../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {NzModalService, NzModalRef} from 'ng-zorro-antd/modal';
import {UtilsModule} from '../../utils/utils.module';
import {debounceTime, map, switchMap} from 'rxjs/operators';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {DatePipe} from '@angular/common';
@Component({
  selector: 'task-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css'],
  providers: [TaskService]
})
export class CalendarComponent implements OnInit, AfterViewInit {
  currentDate: string;
  tplModal: NzModalRef;
  boardId = null; // 存放面板ID
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  selectedGroup: string; // 新增任务选择组ID
  isConfirmLoading = false; // 创建弹窗提交按钮状态
  addTaskData = {}; // 存放新增任务数据
  addPulseNameValue: string; // 添加行输入框绑定值
  group: any = {}; // 当前组件分组数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  personOption: Array<any> = [];  // 指派人组件下拉选项
  selectedPerson: string; // 选中成员ID
  statusWidth = 135; // 标签组件下拉框动态宽度
  isEditVisual = true; // 标签组件下拉框按钮状态
  statusInit = []; // 存放初始状态色块
  statusTemp = []; // 存放操作过程中状态
  statusDel = []; // 存放移除掉的状态;
  addTabBGColor = '#F7F7F7'; // 添加标签默认背景颜色
  defaultStatus: any = {}; // 状态下拉颜色
  addProgressValue = 0; // 存放进度条
  calendarEvent = []; // 存放日历事件
  otherEvent = []; // 存放除日历事件外的其他事件
  groupMap = {};
  nameId = '';
  dateColumns = []; // 所有日期列（包括日期时间）
  dateColumn = {}; // 当前选择的日期列
  dateTimeColumns = []; // 日期时间列
  dateTimeColumn = {}; // 当前选择的日期时间列
  today = new Date(); // 存放当前日期
  dayType = 'month'; // 当前视图类型，默认为-月
  menuFold = false; // 右侧任务列表折叠状态，默认展开
  popVisible = false;
  otherContentHeight = '';
  randomUserUrl: string;
  searchChange$ = new BehaviorSubject('');
  isLoading= false;
  selectedPulseId = '';
  clickButtonLoading: boolean;
  buttonConfigEditData = {};
  buttonConfigStatus = true;
  buttonConfigEditStatus = false;
  buttonConfigTitle = '';
  buttonConfigDisabled = true;
  buttonConfigUrl = '';
  dayContentHeight = '600px';
  selectedTime = '';
  @ViewChild('modalTplContent', { static: true }) modalTplContent: any;
  @ViewChild('chooseGroupContent', {static: true}) chooseGroupContent;
  @ViewChild('tplAddFooter', { static: true }) tplAddFooter: any;
  @ViewChild('tplEditFooter', { static: true }) tplEditFooter: any;
  @Input('nfData') set ChangeData(data: any) {
    if (JSON.stringify(data) !== '{}') {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
      this.boardId = this.boardData.id;
      this.generateGroupMap();
      this.handleDateColumn();
      this.getCalendarEventForMonth();
    }
  }
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
    private modal: NzModalService,
    private utilsModule: UtilsModule,
    private http: HttpClient,
    private datePipe: DatePipe,
    private modalService: NzModalService
  ) { }

  ngOnInit() {
    this.statusInit = JSON.parse(localStorage.getItem('statusInit'));
    this.statusWidth = this.statusInit.length / 4 * 122;
    this.otherContentHeight = window.innerHeight - 350 + 'px';
    this.dayContentHeight = window.innerHeight - 250 + 'px';
  }
  ngAfterViewInit() {
  }
  dayTypeChange(value) {
    if (value !== this.dayType) {
      this.dayType = value;
      this.getEvent();
    }
  }
  // 处理日期列
  handleDateColumn() {
    this.dateColumns = [];
    this.dateTimeColumns = [];
    if (this.boardColumnData) {
      for (const boardColumn of this.boardColumnData) {
        if (boardColumn.type === 'name') {
          this.nameId = boardColumn['id'];
        }
        if (boardColumn.type === 'status') {
          if (boardColumn) {
            this.defaultStatus[boardColumn.id] = boardColumn.labels;
          }
        }
        if (boardColumn.type === 'date') {
          this.dateColumns.push(boardColumn);
        }
        if (boardColumn.type === 'date-time') {
          this.dateColumns.push(boardColumn);
          this.dateTimeColumns.push(boardColumn);
        }
      }
      if (this.dateColumns.length > 0) {
        this.dateColumn = this.dateColumns[0];
      } else {
        this.dateColumn = {};
      }
      if (this.dateTimeColumns.length > 0) {
        this.dateTimeColumn = this.dateTimeColumns[0];
      } else {
        this.dateTimeColumn = {};
      }
    }
  }
  // 日历列表事件
  getEvent() {
    switch (this.dayType) {
      case 'month':
        this.getCalendarEventForMonth();
        break;
      case 'week':
        break;
      case 'day':
        this.getCalendarEventForDay();
        break;
      default:
        break;
    }
  }
  getCalendarEventForMonth() {
    this.calendarEvent = [];
    this.otherEvent = [];
    if (this.dateColumn && JSON.stringify(this.dateColumn) != '{}') {
      this.boardPulseData.forEach(item => {
        if (item['columnValues']) {
          const columnValue = item['columnValues'][this.dateColumn['id']];
          if (columnValue['date']) {
            const o = {
              date: columnValue.date,
              title: item.columnValues[this.nameId],
              pulseId: item.id,
              groupId: item.groupId,
              columnValues: item['columnValues']
            };
            this.calendarEvent.push(o);
          } else {
            const o = {
              title: item.columnValues[this.nameId],
              pulseId: item.id,
              groupId: item.groupId,
              columnValues: item['columnValues'],
              groupColor: this.groupMap[item.groupId] ? this.groupMap[item.groupId]['color'] : ''
            };
            this.otherEvent.push(o);
          }
        }
      });
    } else {
      this.boardPulseData.forEach(item => {
        const o = {
          title: item.columnValues[this.nameId],
          pulseId: item.id,
          groupId: item.groupId,
          columnValues: item['columnValues'],
          groupColor: this.groupMap[item.groupId] ? this.groupMap[item.groupId]['color'] : ''
        };
        this.otherEvent.push(o);
      });
    }
  }
  getCalendarEventForDay() {
    // 初始化一天的24小时
    this.calendarEvent = [];
    for (let i = 0; i < 24; i++) {
      this.calendarEvent.push([]);
    }
    this.otherEvent = [];
    if (this.dateTimeColumn && JSON.stringify(this.dateTimeColumn) !== '{}') {
      this.boardPulseData.forEach(item => {
        if (item['columnValues']) {
          const columnValue = item['columnValues'][this.dateTimeColumn['id']];
          if (columnValue.date) {
            const today = this.datePipe.transform(this.today, 'yyyy-MM-dd');
            if (columnValue.date == today) {
              const o = {
                date: columnValue.date,
                time: columnValue.time,
                title: item.columnValues[this.nameId],
                pulseId: item.id,
                groupId: item.groupId,
                columnValues: item['columnValues'],
                groupColor: this.groupMap[item.groupId] ? this.groupMap[item.groupId]['color'] : '',
                groupName: this.groupMap[item.groupId] ? this.groupMap[item.groupId]['title'] : ''
              };
              const hour = columnValue.time.split(':')[0];
              this.calendarEvent[parseInt(hour)].push(o);
            }
          } else {
            const o = {
              title: item.columnValues[this.nameId],
              pulseId: item.id,
              groupId: item.groupId,
              columnValues: item['columnValues'],
              groupColor: this.groupMap[item.groupId] ? this.groupMap[item.groupId]['color'] : '',
              groupName: this.groupMap[item.groupId] ? this.groupMap[item.groupId]['title'] : ''
            };
            this.otherEvent.push(o);
          }
        }
      });
      for (const hour of this.calendarEvent) {
        hour.sort((a, b) => {
          // a.time 格式为时分秒 11:22:47
          const aTime = a.time.split(':');
          const bTime = b.time.split(':');
          return aTime[1] - bTime[1];
        })
      }
    } else {
      this.boardPulseData.forEach(item => {
        const o = {
          title: item.columnValues[this.nameId],
          pulseId: item.id,
          groupId: item.groupId,
          columnValues: item['columnValues'],
          groupColor: this.groupMap[item.groupId] ? this.groupMap[item.groupId]['color'] : '',
          groupName: this.groupMap[item.groupId] ? this.groupMap[item.groupId]['title'] : ''
        };
        this.otherEvent.push(o);
      });
    }
  }
  menuFoldChange() {
    this.menuFold = !this.menuFold;
  }
  columnChange(column) {
    switch (this.dayType) {
      case 'month':
        if (column.id !== this.dateColumn['id']) {
          this.dateColumn = column;
          this.getCalendarEventForMonth();
        }
        break;
      case 'week':
        break;
      case 'day':
        if (column.id !== this.dateTimeColumn['id']) {
          this.dateTimeColumn = column;
          this.getCalendarEventForDay();
        }
        break;
      default:
        break;
    }
    this.popVisible = false;
  }
  getMonthData(date: Date): number | null {
    return null;
  }
  addTimeTask(i) {
    this.selectedTime = i < 10 ? ('0'+i + ':00:00') : i + ':00:00';
    this.beforeAddTask();
  }
  beforeAddTask() {
    let modal = this.modalService.create({
      nzWidth: 400,
      nzTitle: '选择任务分组',
      nzContent: this.chooseGroupContent,
      nzOkText: '确定',
      nzCancelText: '取消',
      nzOnOk: () => {
        if (this.group && JSON.stringify(this.group) !== '{}') {
          const param = {
            boardId: this.boardId,
            columnValues: {name: '新任务'},
            name: '新任务',
            groupId: this.group.id
          };
          this.taskService.doAddPulse(param).subscribe(res => {
            if (res) {
              this.pulse = res;
              this.selectedPulseId = this.pulse.id;
              this.addPulseNameValue = this.pulse.name;
              this.addTaskData[this.nameId] = this.pulse.name;
              this.selectedGroup = this.group.id;
              // 初始化新增任务字段
              this.boardColumnData.forEach((item) => {
                if (item.type === 'multiple-person') {
                  this.addTaskData[item.id] = {personsAndTeams: []};
                } else if (item.type === 'status') {
                  if (item) {
                    this.defaultStatus[item.id] = item.labels;
                  }
                  this.addTaskData[item.id] = {
                    index: 0
                  };
                } else if (item.type === 'date') {
                  this.addTaskData[item.id] = {
                    date: this.datePipe.transform(this.today, 'yyyy-MM-dd')
                  };
                  this.dateCellValueChange(this.addTaskData, item.id, this.today);
                } else if (item.type === 'date-time') {
                  if (item.id == this.dateTimeColumn['id'] && this.selectedTime) {
                    this.addTaskData[item.id] = {
                      date: this.datePipe.transform(this.today, 'yyyy-MM-dd'),
                      time: this.selectedTime
                    };
                    this.selectedTime = '';
                  } else {
                    this.addTaskData[item.id] = {
                      date: this.datePipe.transform(this.today, 'yyyy-MM-dd'),
                      time: this.datePipe.transform(this.today, 'HH:mm:ss')
                    };
                  }
                  this.dateTimeCellValueChange(this.addTaskData, item.id, this.addTaskData[item.id]);
                } else if (item.type === 'name') {
                  this.addTaskData[item.id] = this.pulse.name;
                } else if (item.type === 'dropdown') {
                  this.addTaskData[item.id] = {ids: []};
                } else if (item.type === 'select') {
                  this.addTaskData[item.id] = {};
                } else if (item.type === 'button') {
                  this.addTaskData[item.id] = {original: ''};
                } else {
                  this.addTaskData[item.id] = '';
                }
              });
              this.pulse.columnValues = this.addTaskData;
              this.boardPulseData.push(this.pulse);
              // 如果没有日期时间列，则将任务添加到otherEvent中
              if (JSON.stringify(this.dateTimeColumn) == '{}') {
                const o = {
                  title: '新任务',
                  pulseId: this.selectedPulseId,
                  groupId: this.pulse.groupId,
                  groupColor: this.groupMap[this.pulse.groupId] ? this.groupMap[this.pulse.groupId]['color'] : '',
                  groupName: this.groupMap[this.pulse.groupId] ? this.groupMap[this.pulse.groupId]['title'] : '',
                  columnValues: this.addTaskData
                };
                this.otherEvent.push(o);
              }
              this.addTask();
            } else {
              this.message.error('创建任务失败!');
            }
          });
        } else {
          this.message.info('请先选择分组！');
          return false;
        }
      },
      nzOnCancel: () => {
        modal.destroy();
      }
    });
  }
  // 添加任务
  addTask() {
    this.onMemberSearch('');
    this.tplModal = this.modalService.create({
      nzContent: this.modalTplContent,
      nzMaskClosable: false,
      nzTitle: null,
      nzFooter: this.tplAddFooter,
      nzWidth: '600px',
      nzWrapClassName: 'vertical-center-modal custom-modal'
    });
  }
  // 编辑查看任务
  editTask(task) {
    this.selectedPulseId = task.pulseId;
    for (let pulse of this.boardPulseData) {
      if (pulse.id === this.selectedPulseId) {
        this.pulse = pulse;
        break;
      }
    }
    this.onMemberSearch('');
    this.selectedGroup = task.groupId;
    this.addPulseNameValue = task.title;
    this.addTaskData = task.columnValues;
    setTimeout(() => {
      this.tplModal = this.modalService.create({
        nzContent: this.modalTplContent,
        nzMaskClosable: false,
        nzTitle: null,
        nzFooter: this.tplEditFooter,
        nzWidth: '600px',
        nzWrapClassName: 'vertical-center-modal custom-modal',
      });
    }, 200);
  }
  // 获取日历选中值
  selectCalendarChange(event) {
    this.currentDate = this.utilsModule.formatDateByGeneral(event);
  }
  // 添加分组
  addNewGroup(boardId) {
    const color = this.utilsModule.getRandomColor();
    const param = {};
    param['title'] = '新组';
    param['color'] = color;
    this.taskService.doAddGroup(boardId, param).subscribe((res: any) => {
      if (res) {
        this.boardGroupData = [
          {
            title: res.title,
            color: res.color,
            id: res.id
          },
          ...this.boardGroupData
        ];
      }
    });
  }

  // 新增弹窗按钮事件
  handleCancel() {
    this.tplModal.destroy();
  }

  pulseNameChange(value) {
    this.taskService.doEditPulseName(this.selectedPulseId, {name: value}).subscribe(res => {});
    if (JSON.stringify(this.dateColumn) != '{}') {
      for (let task of this.calendarEvent) {
        if (task.pulseId == this.selectedPulseId) {
          task.title = value;
          return;
        }
      }
    } else if (JSON.stringify(this.dateTimeColumn) != '{}') {
      for (let hour of this.calendarEvent) {
        if (hour && hour.length > 0) {
          for (let task of hour) {
            if (task.pulseId == this.selectedPulseId) {
              task.title = value;
              return;
            }
          }
        }
      }
    }
    for (let task of this.otherEvent) {
      if (task.pulseId == this.selectedPulseId) {
        task.title = value;
        break;
      }
    }
  }

  popCellValueChange(visible, columnId, value) {
    if (!visible) {
      this.cellValueChange(columnId, value);
    }
  }

  dateCellValueChange(columnValues, columnId, value) {
    const date = {
      date: this.datePipe.transform(value, 'yyyy-MM-dd')
    };
    this.cellValueChange(columnId, date);
    if (columnId == this.dateColumn['id']) {
      const o = {
        date: this.datePipe.transform(value, 'yyyy-MM-dd'),
        title: columnValues[this.nameId],
        pulseId: this.selectedPulseId,
        groupId: this.pulse.groupId,
        columnValues: columnValues
      };
      this.timeEventChangeForMonth(o, value);
    }
  }

  dateTimeCellValueChange(columnValues, columnId, value) {
    this.cellValueChange(columnId, value);
    switch (this.dayType) {
      case 'month':
        if (columnId == this.dateColumn['id']) {
          const o = {
            date: value ? value.date: '',
            title: columnValues[this.nameId],
            pulseId: this.selectedPulseId,
            groupId: this.pulse.groupId,
            columnValues: columnValues
          };
          this.timeEventChangeForMonth(o, value ? value.date : false);
        }
        break;
      case 'week':
        break;
      case 'day':
        if (columnId == this.dateTimeColumn['id']) {
          const o = {
            date: value ? value.date: '',
            time: value ? value.time: '',
            title: columnValues[this.nameId],
            pulseId: this.selectedPulseId,
            groupId: this.pulse.groupId,
            groupColor: this.groupMap[this.pulse.groupId] ? this.groupMap[this.pulse.groupId]['color'] : '',
            groupName: this.groupMap[this.pulse.groupId] ? this.groupMap[this.pulse.groupId]['title'] : '',
            columnValues: columnValues
          };
          this.timeEventChangeForDay(o);
        }
        break;
    }
  }

  timeEventChangeForMonth(o, flag) {
    let index = this.calendarEvent.findIndex(item => item.pulseId == this.selectedPulseId);
    let index2 = this.otherEvent.findIndex(item => item.pulseId == this.selectedPulseId);
    if (flag) {
      if (index < 0) {
        this.calendarEvent.push(o);
      } else {
        this.calendarEvent.splice(index, 1, o);
      }
      if (index2 > -1) {
        this.otherEvent.splice(index2, 1);
      }
    } else {
      if (index > -1) {
        this.calendarEvent.splice(index, 1);
      }
      if (index2 < 0) {
        this.otherEvent.push(o);
      }
    }
  }

  timeEventChangeForDay(o) {
    const currentDay = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    this.removeEventFromOther(o);
    this.removeEventFormCalendar(o);
    if (o.date == currentDay && o.time) {
      let h = parseInt(o.time.split(':')[0]);
      this.calendarEvent[h].push(o);
      this.calendarEvent[h].sort((a, b) => {
        const aTime = a.time.split(':');
        const bTime = b.time.split(':');
        return aTime[1] - bTime[1];
      });
    }
    if (!o.date) {
      this.otherEvent.push(o);
    }
  }

  removeEventFormCalendar(o) {
    let flag = true;
    for (let hour of this.calendarEvent) {
      if (!flag) {
        break;
      }
      if (flag && hour && hour.length > 0) {
        for (let i = 0; i < hour.length; i++) {
          if (hour[i]['pulseId'] == o.pulseId) {
            hour.splice(i, 1);
            flag = false;
            break;
          }
        }
      }
    }
  }

  removeEventFromOther(o) {
    for (let i = 0; i < this.otherEvent.length; i++) {
      if (this.otherEvent[i].pulseId == o.pulseId) {
        this.otherEvent.splice(i, 1);
        break;
      }
    }
  }

  cellValueChange(columnId, value) {
    const param = {
      pulseIds: [this.selectedPulseId],
      columnId: columnId,
      columnValue: value
    };
    this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
  }

  // 按钮组件-自定义按钮点击事件
  buttonCustomClick(column, pulse) {
    let url = '';
    column.config.original.forEach((item) => {
      if (item.id.toString() === pulse.columnValues[column.id].original.toString()) {
        url = item.url;
      }
    });
    const param = {
      'pulseId': pulse.id,
      'columnId': column.id
    };
    this.clickButtonLoading = true;
    this.taskService.buttonClickEvent(url, param).subscribe((res: any) => {
      this.clickButtonLoading = false;
    }, (err) => {
      this.clickButtonLoading = false;
    });
  }

  // 按钮组件-按钮配置pop框
  openButtonConfig(pulseId, column) {
    this.buttonConfigStatus = true;
    // 设置无法删除标识
    const userIds = this.getButtonUserIds(column);
    if (column.config.original && column.config.original.length > 0) {
      column.config.original.forEach((item, index) => {
        item.notRemove = false;
        for (let i = 0; i < userIds.length; i++) {
          if (item.id === userIds[i]) {
            item.notRemove = true;
          }
        }
      });
    }
  }

  // 按钮组件-获取所有按钮已用ID
  getButtonUserIds(column) {
    let useIds = [];
    this.boardPulseData.forEach((pulses) => {
      for (const item in pulses.columnValues) {
        if (pulses.columnValues.hasOwnProperty(item)) {
          if (pulses.columnValues[column.id].original) {
            useIds.push(pulses.columnValues[column.id].original);
          }
        }
      }
    });
    useIds = Array.from(new Set(useIds));
    return useIds;
  }

  buttonSelectChange(event, pulseId, column) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = column.id;
    param['columnValue'] = {
      original: event
    };
    this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
  }

  // 按钮组件-编辑
  editButtonConfig(item) {
    this.buttonConfigEditData = item;
    this.buttonConfigStatus = !this.buttonConfigStatus;
    this.buttonConfigEditStatus = true;
    this.buttonConfigTitle = item.title;
    this.buttonConfigDisabled = item.usable;
    this.buttonConfigUrl = item.url;
  }

  // 按钮组件-删除
  removeButtonConfig(itemId, column) {
    column.config.original = column.config.original.filter(item => item.id !== itemId);
  }

  buttonConfigChange(event) {
    this.buttonConfigDisabled = event;
  }

  // 按钮配置新增/编辑事件
  buttonConfigAdd() {
    this.buttonConfigTitle = null;
    this.buttonConfigDisabled = true;
    this.buttonConfigUrl = null;
    this.buttonConfigStatus = !this.buttonConfigStatus;
    this.buttonConfigEditStatus = false;
  }

  // 按钮配置提交
  buttonConfigSubmit(type, column) {
    if (!this.buttonConfigTitle) {
      this.message.create('error', '请输入按钮名称');
    } else {
      if (type === 'add') {
        const maxId = this.getMaxId(column.config.original) + 1;
        const addObj = {
          'id': maxId,
          'title': this.buttonConfigTitle,
          'type': 'primary',
          'usable': this.buttonConfigDisabled,
          'url': this.buttonConfigUrl
        };
        column.config.original = [
          ...column.config.original,
          addObj
        ];
      } else if (type === 'edit') {
        column.config.original.forEach((item) => {
          if (item.id === this.buttonConfigEditData['id']) {
            item.title = this.buttonConfigTitle;
            item.usable = this.buttonConfigDisabled;
            item.url = this.buttonConfigUrl;
          }
        });
      }
      const param = {
        'config': column.config
      };
      this.taskService.doEditColumnHeader(this.boardId, column.id, param).subscribe((res: any) => {});
      this.buttonConfigStatus = !this.buttonConfigStatus;
    }
  }

  // 获取按钮ID
  getMaxId(data) {
    const ids = [];
    if (data && data.length > 0) {
      data.forEach((item, index) => {
        ids.push(item.id);
      });
      return ids.reduce((a, b) => {
        return b > a ? b : a;
      });
    } else {
      return 0;
    }
  }

  getBoardUserData() {
    this.randomUserUrl = this.taskService.getBoardUser(this.boardData.id);
    const getRandomNameList = (searchKey: string) =>
      this.http
        .get(`${this.randomUserUrl}`, {params: {searchKey}})
        .pipe(map((res: any) => res.users ? res.users.data : []))
        .pipe(
          map((list: any) => {
            return list;
          })
        );
    const optionList$: Observable<any[]> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(500))
      .pipe(switchMap(getRandomNameList));
    optionList$.subscribe(data => {
      this.personOption = data;
      this.isLoading = false;
    });
  }
  // 模糊搜索
  onMemberSearch(value: string): void {
    this.isLoading = true;
    this.searchChange$.next(value);
  }
  chooseUser(target, user) {
    if (!target || !target.personsAndTeams) {
      target = {
        personsAndTeams: []
      }
    }
    let existFlag = false;
    let index = -1;
    for (let person of target.personsAndTeams) {
      index++;
      if (person['id'] == user['id']) {
        existFlag = true;
        break;
      }
    }
    if (existFlag) {
      target.personsAndTeams.splice(index, 1);
    } else {
      target.personsAndTeams.push(user);
    }
  }
  removeUser(target, index) {
    target.splice(index, 1);
  }
  userSelected(target, user): boolean {
    if (target && target.personsAndTeams) {
      for (let person of target.personsAndTeams) {
        if (person.id == user.id) {
          return true;
        }
      }
    }
    return false;
  }
  // 更换状态标签
  clickStatus() {
    this.isEditVisual = true;
    this.statusWidth = this.statusInit.length / 4 * 122;
  }
  // 计算标签组件框宽度
  getStatusWidth(label) {
    const len = label?label.length:0;
    const width = 134;
    if (len > 4) {
      this.statusWidth = Number.isInteger(len / 4) ? len / 4 * width : Math.ceil(len / 4) * width;
    } else {
      this.statusWidth = width;
    }
    return {'width': this.statusWidth + 'px'};
  }
  // 切换选中状态颜色
  changeStatus(column, item) {
    let count = 0;
    let checked = 0;
    this.addTaskData[column.id] = item;
    // 进度条赋值
    this.boardColumnData.forEach((list, index) => {
      if (list.type === 'status') {
        count = count + 1;
        if (this.addTaskData[list.id] && this.addTaskData[list.id].index === 2) {
          checked = checked + 1;
        }
      }
    });
    if (checked) {
      this.addProgressValue = parseInt(((checked / count) * 100).toString(), 0);
    } else {
      this.addProgressValue = 0;
    }
    column['visible'] = false;
  }
  // 鼠标移入移出添加标签背景变色
  mouseEnterStatus(color) {
    this.addTabBGColor = color;
  }
  mouseLeaveStatus() {
    this.addTabBGColor = '#F7F7F7';
  }
  // 标签组件切换到编辑状态
  editStatus(column, pulse) {
    this.isEditVisual = !this.isEditVisual;
    this.getStatusWidth(this.statusInit);
    // 处理编辑状态选项
    this.statusTemp = column.labels;
    // 状态标签列表增加已用标签
    const tempList = [];
    this.boardPulseData.forEach((list, i) => {
      for (let k = 0; k < this.boardColumnData.length; k++) {
        if (this.boardColumnData[k].type === 'status') {
          tempList.push(list.columnValues[this.boardColumnData[k].id].index);
        }
      }
    });
    this.statusTemp.map((item, i) => {
      item.use = false;
      if (item.index === 0) {
        this.statusTemp.splice(i, 1);
      }
    });
    tempList.forEach((item, index) => {
      for (let i = 0; i < this.statusTemp.length; i++) {
        if (item === this.statusTemp[i].index) {
          this.statusTemp[i].use = true;
        }
      }
    });
    // 状态标签未选列表
    const arr = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
    this.statusDel = arr;
  }
  // 标签组件提交编辑
  submitEditStatus(columnId, boardId) {
    const param = {
      'labels': this.statusTemp
    };
    this.defaultStatus[columnId] = this.statusTemp;
    this.taskService.doAddStatusLabel(boardId, columnId, param).subscribe((res: any) => {
      this.boardColumnData.forEach((item, index) => {
        if (item.id === columnId) {
          item.labels = this.statusTemp;
        }
        let count = 0;
        if (item.type === 'status') {
          for (let i = 0; i < item.labels.length; i++) {
            if (item.labels[i].index === 0) {
              count = count + 1;
            }
          }
          if (count === 0) {
            if (item.type === 'status') {
              const o = {
                'color': 'rgb(196, 196, 196)',
                'index': 0,
                'label': ''
              };
              item.labels.push(o);
            }
          }
        }
      });
      this.isEditVisual = !this.isEditVisual;
    });
  }
  // 删除状态标签
  removeStatusTag(id) {
    this.statusTemp = this.statusTemp.filter(d => d.index !== id);
    this.statusInit.forEach((item, index) => {
      if (id === item.index) {
        this.statusDel.push(item);
      }
    });
  }
  // 添加状态标签
  addStatusTag() {
    const arr = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
    if (arr.length > 0) {
      this.statusTemp = [
        ...this.statusTemp,
        {
          index: arr[0].index,
          label: '',
          color: arr[0].color
        }
      ];
      this.statusDel = this.statusDel.filter(d => d.color !== arr[0].color);
    }
  }
  // 添加自定义颜色标签
  addCustomTag(index) {
    const arr = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
    if (arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        if (index === arr[i].index) {
          this.statusTemp = [
            ...this.statusTemp,
            {
              index: arr[i].index,
              label: '',
              color: arr[i].color
            }
          ];
          this.statusDel = this.statusDel.filter(d => d.index !== arr[i].index);
        }
      }
    }
    this.addTabBGColor = '#F7F7F7';
  }
  // 平均分配
  progressAverage(count) {
    const value = [];
    let remainder = 100 % count;
    if (remainder === 0) {
      for (let i = 0; i < count; i++) {
        value.push(100 / count);
      }
    } else {
      for (let i = 0; i < count; i++) {
        if (remainder !== 0) {
          value.push(parseInt(((100 / count) + 1).toString(), 0));
          remainder = remainder - 1;
        } else {
          const num = 100 / count;
          value.push( parseInt(num.toString(), 0) );
        }
      }
    }
    return value;
  }
  // 前一天
  preDay() {
    this.today = new Date(this.today.getTime() - 24*60*60*1000);
    this.getEvent();
  }
  // 切换到今天
  switchToday() {
    this.today = new Date();
    this.getEvent();
  }
  // 后一天
  nextDay() {
    this.today = new Date(this.today.getTime() + 24*60*60*1000);
    this.getEvent();
  }
  // 生成group Map
  generateGroupMap() {
    this.groupMap = {};
    if (this.boardGroupData) {
      for (const group of this.boardGroupData) {
        this.groupMap[group.id] = group;
      }
    }
  }
}
